import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSelectMultipleWrapper, CustomSelectMultipleWrapperProps, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModelWithSource } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomSelectMultipleWrapperProps & {
    input: InputModelWithSource;
    message?: string;
};

const GenericSelectMultiple: InputWithMeta<Props> = (props: Props) => {
    const { input, allowClear = true, message, ...rest } = props;

    return (
        <CustomFormItem name={input.guid} required={input.required} message={message} isReadOnly={input.isReadOnly}>
            <CustomSelectMultipleWrapper
                input={input}
                options={input.sourceProvider.options}
                topRightNode={<InputControls input={input} />}
                allowClear={allowClear}
                {...rest}
            />
        </CustomFormItem>
    );
};

GenericSelectMultiple.meta = {
    inputType: InputModelWithSource.name
};

export default observer(GenericSelectMultiple);
